import {
  collection,
  getDocs,
  query,
  where,
  orderBy
} from 'firebase/firestore';
import { db } from './firebase/config';

const COLLECTION = 'gallery';

export const galleryService = {
  /**
   * Get all visible gallery images for public website
   */
  async getPublicGallery(category = null) {
    try {
      let q = query(
        collection(db, COLLECTION),
        where('visible', '==', true),
        orderBy('uploadedAt', 'desc')
      );

      if (category && category !== 'all') {
        q = query(q, where('category', '==', category));
      }

      const snapshot = await getDocs(q);
      return snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
    } catch (error) {
      console.error('Error fetching gallery:', error);
      return [];
    }
  },

  /**
   * Get featured images
   */
  async getFeatured(limit = 6) {
    try {
      const q = query(
        collection(db, COLLECTION),
        where('visible', '==', true),
        where('featured', '==', true),
        orderBy('uploadedAt', 'desc')
      );

      const snapshot = await getDocs(q);
      return snapshot.docs.slice(0, limit).map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
    } catch (error) {
      console.error('Error fetching featured images:', error);
      return [];
    }
  },

  /**
   * Get available categories
   */
  async getCategories() {
    try {
      const images = await this.getPublicGallery();
      const categories = [...new Set(images.map(img => img.category))];
      return categories.sort();
    } catch (error) {
      console.error('Error fetching categories:', error);
      return [];
    }
  }
};

export default galleryService;
